import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { EStore } from '@gelato-api-ui/core/e-commerce/e-store';
import { ECommerceProductTemplatesFacade } from '@api-ui-app/src/app/e-commerce-product-templates/e-commerce-product-templates.facade';
import { DialogRef } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-ref';
import { DIALOG_DATA } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-tokens';
import { DialogSize } from '@gelato-api-ui/sdk/src/lib/shared/dialog/types/dialog-size';

interface ProductTemplatesStoreSelectionModalContext {
  templateName: string;
}

@Component({
  selector: 'gd-product-templates-store-selection-modal',
  templateUrl: './product-templates-store-selection-modal.component.html',
  styleUrls: ['./product-templates-store-selection-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplatesStoreSelectionModalComponent implements OnInit {
  storesList$ = this.facade.storesList$;
  isStoresListLoading$ = this.facade.isStoresListLoading$;
  size = DialogSize.Tiny;
  templateName: string;

  constructor(
    private readonly dialogRef: DialogRef,
    @Inject(DIALOG_DATA) private readonly dialogData: ProductTemplatesStoreSelectionModalContext,
    private readonly facade: ECommerceProductTemplatesFacade,
  ) {}

  ngOnInit() {
    this.templateName = this.context?.templateName;
    this.facade.loadStoresList();
  }

  get context() {
    return this.dialogData;
  }

  selectStore(store: EStore) {
    this.dialogRef.close(store);
  }

  cancel() {
    this.dialogRef.close(undefined);
  }
}
